import {InvitedUserFields} from 'hubbl-shared';
import {createAppAsyncThunk} from '../appAsyncThunk';
import {Api} from '../../api';
import {createCompanyForCurrentUser} from '../user/UserThunks';
import {fetchCompany} from '../company/CompanyThunks';
import {fetchUserDetails} from '../user/UserThunks';
import {getAuthUser} from '../../utils/user/getAuthUser';

export const setWrittenCompanyName = createAppAsyncThunk(
  'get-started/setWrittenCompanyName',
  async (writtenCompanyName: string) => {
    return writtenCompanyName;
  },
);

export const setUserFullName = createAppAsyncThunk(
  'get-started/setUserFullName',
  async (userFullName: string) => {
    return userFullName;
  },
);

export const setInvitedEmployees = createAppAsyncThunk(
  'get-started/setInvitedEmployees',
  async (invitedEmployees: InvitedUserFields[]) => {
    return invitedEmployees;
  },
);

export const setRestrictedMailDomains = createAppAsyncThunk(
  'get-started/setRestrictedMailDomains',
  async (domains: string[]) => {
    return domains;
  },
);

export const finalizeCompanyCreation = createAppAsyncThunk(
  'get-started/finalizeCompanyCreation',
  async (_, thunkApi) => {
    const state = thunkApi.getState();
    const {writtenCompanyName, userFullName, invitedEmployees} =
      state.getStarted;

    // Create company and move user
    const result = await thunkApi
      .dispatch(
        createCompanyForCurrentUser({
          companyName: writtenCompanyName,
          fullName: userFullName,
        }),
      )
      .unwrap();

    const user = getAuthUser();

    if (!user) {
      throw new Error('User not found');
    }

    // Mark user as onboarded since they completed the get-started flow
    await Api.user.updateUserDetails(result.companyId, user.uid, {
      isOnboarded: true,
    });

    // Invite employees if any
    if (invitedEmployees.length > 0) {
      await Api.invitedUsers.onInviteUsersByEmail({
        companyId: result.companyId,
        invitedUsers: invitedEmployees,
        customDescription: '',
      });
    }

    // Refresh user details and company to get updated state
    await thunkApi.dispatch(fetchUserDetails());
    await thunkApi.dispatch(fetchCompany());

    return result;
  },
);
